/**
 * OAuth Environment Configuration Utilities
 *
 * Provides type-safe access to OAuth environment variables.
 * Defaults to false for missing or invalid values (conservative approach).
 */

function parseEnvBoolean(value: string | undefined): boolean {
  if (!value) {
    return false;
  }

  const normalized = value.toLowerCase().trim();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

export function isOAuthGoogleEnabledInEnv(): boolean {
  return parseEnvBoolean(process.env.REACT_APP_OAUTH_GOOGLE_ENABLED);
}

export function isOAuthFacebookEnabledInEnv(): boolean {
  return parseEnvBoolean(process.env.REACT_APP_OAUTH_FACEBOOK_ENABLED);
}
